import React from 'react'
import { BTextInput } from '@prague-digi/ui-components'
import { Field } from 'redux-form'
import { Message } from 'react-intl'

import { fieldAdapter, FieldProps } from '../../utils/field'

interface Props {
  autoComplete?: string
  autoFocus?: boolean
  defaultValue?: any
  maxValue?: number
  messages?: {
    error?: Message | string
    label: Message | JSX.Element | string
    notice?: Message | string
    placeholder?: Message | string
    warning?: Message | string
  }
  minValue?: number
  name: string
  noMessage?: boolean
  onBlur?: any
  onChange?: any
  onEnterPress?: Function
  onFocus?: any
  tabIndex?: number
  testid: string
  theme?: any
  type?: string
  value?: any
}

const SAFE_INT = 9007199254740991

const TextInput = ({
  maxValue,
  minValue,
  onBlur,
  onChange,
  onEnterPress,
  onFocus,
  ...props
}: Props & FieldProps) => {
  const handleBlur = (evt: any) => {
    if (evt) {
      let strVal = `${evt.target.value}`
      strVal = strVal.trim()
      if (props.type === 'number') {
        const trimmedVal = strVal
          .replace(/\s/g, '')
          .replace(/,/g, '.')
          .replace(/[^0-9.]/g, '')
        let numVal = Number(trimmedVal)
        const useNumeric = trimmedVal !== '' && !isNaN(numVal) && Math.abs(numVal) < SAFE_INT
        if (!useNumeric) {
          numVal = props.defaultValue !== undefined ? props.defaultValue : 0
        }

        if (minValue !== undefined && numVal < minValue) {
          numVal = minValue
        }

        if (maxValue !== undefined && numVal > maxValue) {
          numVal = maxValue
        }
        // eslint-disable-next-line no-param-reassign
        evt.target.value = numVal
      } else {
        // eslint-disable-next-line no-param-reassign
        evt.target.value = strVal
      }
      onBlur(evt)
    }
  }

  const handleKeyDown = (event: any) => {
    if (event.which === 13 && event.target.blur) {
      event.target.blur()

      onEnterPress && onEnterPress(event)
    }
  }

  return (
    <BTextInput
      {...props}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
    />
  )
}

export const renderTextInput = fieldAdapter(TextInput)

export const TextInputField = (props: Props) => <Field {...props} component={renderTextInput} />

export default TextInputField
